module.exports = __webpack_public_path__ + "img/routes.31e1529c.png";